export default "__VITE_ASSET__79aec82b__"